import { render, staticRenderFns } from "./cover-size.vue?vue&type=template&id=57a6d1b6&scoped=true"
import script from "./cover-size.vue?vue&type=script&lang=js"
export * from "./cover-size.vue?vue&type=script&lang=js"
import style0 from "./cover-size.vue?vue&type=style&index=0&id=57a6d1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a6d1b6",
  null
  
)

export default component.exports